import type { Api_ChatRoom, Maybe } from '$lib/types/api/graphql';
import { writable } from 'svelte/store';

export const activeProfileDrawerSlug = writable<Maybe<string>>('');
export const activeProfileShowMore = writable<Maybe<boolean>>(false);

export const activeChatRoomDrawer = writable<Maybe<Api_ChatRoom>>(null);
export const activeNewAccountChatDrawerId = writable<Maybe<string>>(null);

export const backButtonHref = writable<Maybe<string>>(null);

export const navigation = writable({
  sidebarDrawerOpen: false,
  supportersDrawerOpen: false,
  userDrawerOpen: false,
  calendarDrawerOpen: false,
  communitiesDrawerOpen: false,
  gamesDrawerOpen: false,
  notificationsDrawerOpen: false,
  chatDrawerOpen: false,
  createModalOpen: false,
  videoUploadsDrawerOpen: false
});
